/* -------- Vue START --------*/ 
import { createApp } from 'vue';
import player from './pages/player.vue';
import AudioVisual from 'vue-audio-visual';
import Datepicker from '@vuepic/vue-datepicker';

const app = createApp({});
app.component('player', player);
app.component('Datepicker', Datepicker);
app.use(AudioVisual);
app.mount('#app');
/* -------- Vue END --------*/ 